/**
 * Firebase Configuration - Admin Portal
 *
 * Initialize Firebase app with environment variables
 */

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Firebase configuration from environment variables (Auth only)
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const requiredKeys = ['apiKey', 'authDomain', 'projectId', 'appId'];
const missingKeys = requiredKeys.filter(
  (key) => !firebaseConfig[key as keyof typeof firebaseConfig]
);

if (missingKeys.length > 0) {
  console.error('❌ Missing Firebase configuration keys:', missingKeys);
  console.error(
    'Please set the following environment variables:',
    missingKeys
      .map(
        (key) => `VITE_FIREBASE_${key.replace(/([A-Z])/g, '_$1').toUpperCase()}`
      )
      .join(', ')
  );
}

export const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth (admin portal only needs auth)
export const auth = getAuth(app);

console.log('🔥 Firebase initialized for Admin Portal:', {
  projectId: firebaseConfig.projectId,
  hasAuth: !!auth,
});

// Export config for debugging
export { firebaseConfig };
